import React, { Dispatch, SetStateAction } from 'react'
import { Offset, Placement } from '@restart/ui/usePopper'
import clsx from 'clsx'

import { ChevronRight } from '@makyoapp/makyo-icon/icon'
import { DD, useTheme } from '@makyoapp/makyo-ui'

export function VariableWrapper({
  id,
  title,
  icon,
  show,
  setShow,
  children,
  defaultHeight,
  defaultWidth = true,
  defaultMenuPad = true,
  menuClassName,
  placement,
  onToggle,
  portalMenu,
  menuOffset,
  menuAlwaysRender = false,
}: {
  id?: string
  title: React.ReactNode
  icon: React.ReactNode
  children: React.ReactNode
  show: boolean
  setShow?: Dispatch<SetStateAction<boolean>>
  defaultWidth?: boolean
  defaultHeight?: boolean
  defaultMenuPad?: boolean
  menuClassName?: string
  placement?: Placement
  onToggle?: (nextShow: boolean, meta: unknown) => void
  portalMenu?: boolean
  menuOffset?: Offset
  menuAlwaysRender?: boolean
}) {
  const { state: themeState } = useTheme()

  return (
    <DD
      id={id}
      menuAlwaysRender={menuAlwaysRender}
      show={show}
      onToggle={(nextShow, meta) => {
        const evt = meta.originalEvent
        const tgt = evt?.target as HTMLElement
        if (
          tgt?.closest('.sdd-search-wrap') ||
          tgt?.tagName === 'INPUT' ||
          tgt?.className?.includes?.('search-input')
        ) {
          return
        }
        onToggle ? onToggle(nextShow, meta) : setShow?.(nextShow)
      }}
      className='w-full'
      toggleClassName={clsx('sdd-item mk-ddi mk-dd-row flex-c w-full', show && 'sdd-item-selected')}
      menuClassName={clsx(
        //'mk-dd-menu border bdr',
        //'border bdr',
        defaultWidth && 'w-[240px]',
        menuClassName
      )}
      menuWrapperClassName={clsx(defaultMenuPad && 'py-2', 'sdd-menu-subc')}
      menuNoPad
      menuDefaultSize={defaultHeight}
      menuOffSet={menuOffset}
      /*menuOffSet={(details) => {
        const overHeight =
          details.popper.height > 200 && details.placement === 'auto-end'
        return overHeight ? [details.reference.y + 58, 8] : [0, 8]
        //return [0, 8]
      }}*/
      placement={placement ? placement : themeState.dir === 'rtl' ? 'left' : 'right'}
      portalMenu={portalMenu}
      toggle={() => {
        return (
          <div className='flex-c w-full pointer-events-none'>
            <div className='flex-c w-full pointer-events-none'>
              {icon}
              <div className='pointer-events-none'>{title}</div>
            </div>
            <ChevronRight className='pointer-events-none' />
          </div>
        )
      }}
    >
      <div className='overflow-auto'>{children}</div>
    </DD>
  )
}
